export async function loadIcons(): Promise<void> {
  if (document.getElementById("material-icons-stylesheet")) {
    return;
  }

  await new Promise((resolve, reject) => {
    if (document.getElementById("material-icons-stylesheet")) {
      resolve(undefined);
      return;
    }

    const link = document.createElement("link");
    link.id = "material-icons-stylesheet";
    link.rel = "stylesheet";
    link.type = "text/css";
    link.href = import.meta.env.VITE_ICONS_STYLESHEET;
    link.addEventListener("load", resolve);
    link.addEventListener("error", reject);
    document.head.append(link);
  });
}
